export default __webpack_public_path__ + "static/media/wallpaper_bg4.fb781887.png";